import lazyLoading from './lazyLoading';

export default {
    path: '/app',
    meta: {
        icon: 'el-icon-setting',
        label: '配置管理',
        hidden: false
    },
    component: require('../views/Home'),
    children: [
        {
            name: 'TopicList',
            path: 'topic-list',
            component: lazyLoading('app/TopicList'), // 加载模块
            meta: {
                label: 'Topic管理',
                hidden: false,
                api: [
                    // 权限验证
                    // Apis.qukan.config.list
                ]
            }
        },
        {
            name: 'TopicCmdList',
            path: 'topic-cmd-list',
            component: lazyLoading('app/TopicCmdList'), // 加载模块
            meta: {
                label: 'Topic包含CMD列表',
                hidden: true
            }
        },
        {
            name: 'RangeList',
            path: 'cmd-range-list',
            component: lazyLoading('app/CmdRangeList'), // 加载模块
            meta: {
                label: 'CMD管理',
                hidden: true,
                api: [
                    // 权限验证
                    // Apis.qukan.config.list
                ]
            }
        },
        {
            name: 'CmdList',
            path: 'cmd-list',
            component: lazyLoading('app/CmdList'), // 加载模块
            meta: {
                label: 'CMD列表',
                hidden: true
            }
        },
        {
            name: 'ActionMetricList',
            path: 'action-metric-list',
            component: lazyLoading('app/ActionMetricList'), // 加载模块
            meta: {
                label: 'actionmetric列表',
                hidden: true
            }
        },
        {
            name: 'CmdDetailList',
            path: 'cmd-detail-list',
            component: lazyLoading('app/CmdDetailList'), // 加载模块
            meta: {
                label: 'cmddetail列表',
                hidden: true
            }
        }
        // {
        //     name: 'Approve',
        //     path: 'approve-list',
        //     component: lazyLoading('approve/ApproveList'), // 审批列表
        //     meta: {
        //         label: '审批列表',
        //         hidden: false
        //     }
        // }
    ]
};



// WEBPACK FOOTER //
// ./src/router/app.js